const invertedMessages = {
  'Set Up Identity Verification Today to Boost Security':
    'external.idpSetup.titleIV',
  'explanation etc. Onboarding employees. verification of identity':
    'external.idpSetup.subTitle',
  'Choose a provider': 'external.idpSetup.chooseProvider',
  'Set Up': 'external.idpSetup.setUpBtn',
};

export default invertedMessages;
